import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import { useOktaAuth } from "@okta/okta-react";
import * as React from "react";
import VersionInfo from "../VersionInfo";
import { AccountPopoverFooter } from "./AccountPopoverFooter";
import { AccountPreview, AccountPreviewVariant } from "./AccountPreview";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

function Account({ variant }: { variant: AccountPreviewVariant }) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { oktaAuth } = useOktaAuth();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!oktaAuth.isAuthenticated()) {
    return <SignInButton />;
  } else {
    return (
      <React.Fragment>
        <AccountPreview
          variant={variant}
          handleClick={handleClick}
          open={open}
        />
        <Popover
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          disableAutoFocus
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: (theme) =>
                  `drop-shadow(0px 2px 8px ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.32)"})`,
                mt: 1,
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  bottom: 10,
                  left: 0,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translate(-50%, -50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            },
          }}
        >
          <Stack direction="column">
            <AccountPreview variant="expanded" />
            <Divider />
            <AccountPopoverFooter>
              <SignOutButton />
              <VersionInfo />
            </AccountPopoverFooter>
          </Stack>
        </Popover>
      </React.Fragment>
    );
  }
}

export { Account };
